import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  no_image,
  search_icon,
} from "../../assets/imgs";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  useAmenitiesListAddMutation,
  useAmenitiesListStatusMutation,
  useAmenitiesListUpdateMutation,
  useAmenitiesPostListMutation,
  useLazyAmenitiesListQuery,
  useLazyAmenitiesViewQuery,
} from "../redux/api/api";
import { toast } from "react-toastify";

const Amenities = () => {
  const [popup, setPopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [image, setImage] = useState(null); // State for the selected image
  const [croppedImage, setCroppedImage] = useState(null); // State for the cropped image
  const cropperRef = useRef(null); // Ref for the Cropper component
  const fileInputRef = useRef(null); // Ref for the file input
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [name, setName] = useState();
  const [list, setList] = useState([]);
  const [type, setType] = useState();
  const [id, setId] = useState();

  const [height, setHeight] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);

  const rolePermissions = JSON.parse(localStorage.getItem("permissions"));

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result); // Set the selected image for cropping
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle image cropping
  const handleCrop = () => {
    if (cropperRef.current) {
      const cropper = cropperRef.current.cropper;
      const croppedImageUrl = cropper.getCroppedCanvas().toDataURL(); // Get cropped image as data URL
      fetch(croppedImageUrl)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "File name", { type: "image/png" });
          setCroppedImage(file); // Set the cropped image
        });
      setImage(null); // Close the cropper after cropping
      setHeight(false);
    }
  };

  const [amenitiesListApi] = useAmenitiesPostListMutation();
  const [amenitiesStatusApi] = useAmenitiesListStatusMutation();
  const [amenitiesAddApi] = useAmenitiesListAddMutation();
  const [amenitiesEditApi] = useAmenitiesListUpdateMutation();
  const [amenitiesViewApi] = useLazyAmenitiesViewQuery();

  const amenitiesList = (page, search) => {
    const formdata = new FormData();
    formdata.append("page", page);
    formdata.append("row", 10);
    if (search) {
      formdata.append("search", search);
    }
    amenitiesListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          temp.push(obj);
        });
        setList(temp);
        setPopup(false);
        setPagecount(res?.pagination);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const amenitiesListView = (id) => {
    amenitiesViewApi(id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.amenity) {
          setPopup(true);
          setType("edit");
          setName(res?.amenity?.name);
          setCroppedImage(res?.amenity?.image_url);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const amenitiesStatus = (id) => {
    const formdata = new FormData();
    formdata.append("id", id);
    amenitiesStatusApi(id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast(res?.message);
          amenitiesList();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const amenitiesAdd = () => {
    if (!name) {
      toast.error("Enter Name");
      return;
    }
    if (!croppedImage) {
      toast.error("Select Image");
      return;
    }
    const formdata = new FormData();
    formdata.append("name", name);
    formdata.append("image", croppedImage);
    setLoader(true);
    amenitiesAddApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          setPopup(false);
          toast.success(res?.message);
          amenitiesList();
          setName("");
          setCroppedImage(no_image);
          setId("");
          setType("");
        }
        if (res?.message == "The name has already been taken.") {
          toast.error(res?.message);
          setPopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const amenitiesEdit = () => {
    if (!name) {
      toast.error("Enter Name");
      return;
    }
    if (!croppedImage) {
      toast.error("Select Image");
      return;
    }
    const formdata = new FormData();
    formdata.append("name", name);
    formdata.append("id", id);
    if (croppedImage?.name) {
      formdata.append("image", croppedImage);
    }
    setLoader(true);
    amenitiesEditApi({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          setPopup(false);
          toast.success(res?.message);
          amenitiesList();
          setName("");
          setCroppedImage(no_image);
          setId("");
          setType("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    amenitiesList(pageno);
    if (id) {
      amenitiesListView(id);
    }
  }, [pageno]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>
          );
        },
      },
      {
        Header: "Image",
        accessor: "image_url",
        Cell: ({ value, row }) => {
          return (
            <img
              src={value}
              style={{ height: "50px", width: "70px", borderRadius: "5px" }}
            />
          );
        },
      },
      {
        Header: "Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <select
                disabled={
                  rolePermissions?.includes("CAN-STATUS-MASTER") ? false : true
                }
                value={value}
                onChange={() => amenitiesStatus(row.original.id)}
                className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${
                  value == 1 ? "active-btn" : "suspend-btn"
                }`}
              >
                <option
                  className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black"
                  value={1}
                >
                  Active
                </option>
                <option
                  className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black"
                  value={0}
                >
                  Deactive
                </option>
              </select>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {rolePermissions?.includes("CAN-EDIT-MASTER") && (
                <button
                  onClick={() => {
                    amenitiesListView(row.original.id);
                    setId(row.original.id);
                  }}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="mx-2 edit-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Masters - Amenities
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              onChange={(e) => amenitiesList(1, e.target.value)}
            />
            <img src={search_icon} className="search" />
          </div>
          {rolePermissions?.includes("CAN-ADD-MASTER") && (
            <button
              onClick={() => {
                setPopup(true);
                setType("add");
              }}
              className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn"
            >
              + Add
            </button>
          )}
        </div>
      </div>

      <div>
        <Table
          columns={columns}
          data={list}
          setPageno={setPageno}
          pagecount={pagecount}
          show={true}
        />
      </div>

      {popup && (
        <div className="img-popup-design-new">
          <div
            className="img-popup-new"
            style={{
              height: height == true ? "580px" : "450px",
            }}
          >
            <div className="d-flex ac-jb">
              <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                {type == "add" ? "Add" : type == "edit" ? "Edit" : ""} Amenities
              </h4>
              <button
                className="cust-btn"
                onClick={() => {
                  setPopup(false);
                  setName("");
                  setCroppedImage(null);
                  setImage("");
                  setLoader(false);
                }}
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Name
            </h4>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Name"
            />

            <div className="d-flex ac-jb mt-3">
              <div className="w-50">
                <h4 className="f1 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 mt-3 primary1">
                  Image (max 100px * 100px)
                </h4>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  ref={fileInputRef} // Use the ref here
                />
                <button
                  className="upload-btn f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mb-3"
                  onClick={() => {
                    fileInputRef.current.click();
                    setHeight(true);
                  }}
                >
                  Select Image
                </button>
              </div>
              <div className="w-50">
                {image && (
                  <div>
                    <Cropper
                      ref={cropperRef}
                      src={image}
                      aspectRatio={1} // Square aspect ratio
                      guides={false}
                      viewMode={1}
                      autoCropArea={1}
                      background={false}
                      responsive={true}
                      style={{ height: 300, width: "100%" }} // Ensure the cropper has a defined size
                    />
                    <button
                      className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                      onClick={handleCrop}
                    >
                      Crop Image
                    </button>
                  </div>
                )}
                {console.log(croppedImage, "cropped image", croppedImage)}
                <img
                  onChange={(e) => setCroppedImage(e.target.value)}
                  src={
                    croppedImage
                      ? croppedImage?.name
                        ? URL.createObjectURL(croppedImage)
                        : croppedImage
                      : no_image
                  }
                  style={{
                    width: "150px",
                    height: "150px",
                    margin: "10px 0px",
                  }}
                  alt="Cropped"
                />
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={() => {
                  type == "edit" ? amenitiesEdit() : amenitiesAdd();
                }}
                className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3"
              >
                {loader && (
                  <div
                    class="spinner-border spinner-border-sm "
                    role="status"
                    style={{ marginRight: "5px" }}
                  ></div>
                )}{" "}
                {type == "edit" ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Amenities;
